!function (n, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react-dom"), require("react"));else if ("function" == typeof define && define.amd) define(["react-dom", "react"], t);else {
    var r = "object" == typeof exports ? t(require("react-dom"), require("react")) : t(n.ReactDOM, n.React);
    for (var e in r) ("object" == typeof exports ? exports : n)[e] = r[e];
  }
}(window, function (n, t) {
  return function (n) {
    var t = {};
    function r(e) {
      if (t[e]) return t[e].exports;
      var o = t[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return n[e].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = n, r.c = t, r.d = function (n, t, e) {
      r.o(n, t) || Object.defineProperty(n, t, {
        enumerable: !0,
        get: e
      });
    }, r.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, r.t = function (n, t) {
      if (1 & t && (n = r(n)), 8 & t) return n;
      if (4 & t && "object" == typeof n && n && n.__esModule) return n;
      var e = Object.create(null);
      if (r.r(e), Object.defineProperty(e, "default", {
        enumerable: !0,
        value: n
      }), 2 & t && "string" != typeof n) for (var o in n) r.d(e, o, function (t) {
        return n[t];
      }.bind(null, o));
      return e;
    }, r.n = function (n) {
      var t = n && n.__esModule ? function () {
        return n.default;
      } : function () {
        return n;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (n, t) {
      return Object.prototype.hasOwnProperty.call(n, t);
    }, r.p = "/", r(r.s = 9);
  }([function (n, t, r) {
    !function (n) {
      "use strict";

      function t(n, r, e) {
        return void 0 === r ? function (r, e) {
          return t(n, r, e);
        } : void 0 === e ? function (e) {
          return t(n, r, e);
        } : void 0 !== e[n] ? e[n](r) : void 0;
      }
      function r(n) {
        return function (t, r) {
          return void 0 === r ? function (r) {
            return n(t, r);
          } : n(t, r);
        };
      }
      function e(n) {
        return function (t, e, o) {
          return void 0 === e ? r(function (r, e) {
            return n(t, r, e);
          }) : void 0 === o ? function (r) {
            return n(t, e, r);
          } : n(t, e, o);
        };
      }
      var o = e(function (n, t, r) {
        switch (n) {
          case "+":
            return t + r;
          case "-":
            return t - r;
          case "/":
            return t / r;
          case "*":
            return t * r;
          case "%":
            return t % r;
        }
      });
      function u(n, t) {
        return void 0 === t ? function (t) {
          return u(n, t);
        } : void 0 !== t[n] ? t[n]() : void 0;
      }
      var i = e(function (n, t, r) {
          return r.concat().map(function (e, o) {
            return o === t ? n(r[t]) : e;
          });
        }),
        c = r(function (n, t) {
          if (void 0 === t.length) return function (n, t) {
            var r = {};
            for (var e in t) n(t[e]) && (r[e] = t[e]);
            return r;
          }(n, t);
          for (var r = -1, e = 0, o = t.length, u = []; ++r < o;) {
            var i = t[r];
            n(i) && (u[e++] = i);
          }
          return u;
        }),
        f = r(function (n, t) {
          return c(n, t).length === t.length;
        }),
        a = r(function (n, t) {
          for (var r = 0; r < t.length;) {
            if (n(t[r])) return !0;
            r++;
          }
          return !1;
        }),
        l = r(function (n, t) {
          if ("string" == typeof t) return "" + t + n;
          var r = t.concat();
          return r.push(n), r;
        }),
        s = r(function (n, t) {
          return function (r) {
            return n(r) && t(r);
          };
        });
      function p() {
        for (var n = arguments.length, t = Array(n), r = 0; r < n; r++) t[r] = arguments[r];
        return function (n) {
          for (var r = t.slice(); r.length > 0;) n = r.pop()(n);
          return n;
        };
      }
      var y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
          return typeof n;
        } : function (n) {
          return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
        },
        d = (function () {
          function n(n) {
            this.value = n;
          }
          function t(t) {
            var r, e;
            function o(r, e) {
              try {
                var i = t[r](e),
                  c = i.value;
                c instanceof n ? Promise.resolve(c.value).then(function (n) {
                  o("next", n);
                }, function (n) {
                  o("throw", n);
                }) : u(i.done ? "return" : "normal", i.value);
              } catch (n) {
                u("throw", n);
              }
            }
            function u(n, t) {
              switch (n) {
                case "return":
                  r.resolve({
                    value: t,
                    done: !0
                  });
                  break;
                case "throw":
                  r.reject(t);
                  break;
                default:
                  r.resolve({
                    value: t,
                    done: !1
                  });
              }
              (r = r.next) ? o(r.key, r.arg) : e = null;
            }
            this._invoke = function (n, t) {
              return new Promise(function (u, i) {
                var c = {
                  key: n,
                  arg: t,
                  resolve: u,
                  reject: i,
                  next: null
                };
                e ? e = e.next = c : (r = e = c, o(n, t));
              });
            }, "function" != typeof t.return && (this.return = void 0);
          }
          "function" == typeof Symbol && Symbol.asyncIterator && (t.prototype[Symbol.asyncIterator] = function () {
            return this;
          }), t.prototype.next = function (n) {
            return this._invoke("next", n);
          }, t.prototype.throw = function (n) {
            return this._invoke("throw", n);
          }, t.prototype.return = function (n) {
            return this._invoke("return", n);
          };
        }(), function (n) {
          if (Array.isArray(n)) {
            for (var t = 0, r = Array(n.length); t < n.length; t++) r[t] = n[t];
            return r;
          }
          return Array.from(n);
        });
      function v(n) {
        var t = void 0 === n ? "undefined" : y(n);
        if (null === n) return "Null";
        if (void 0 === n) return "Undefined";
        if ("boolean" === t) return "Boolean";
        if ("number" === t) return "Number";
        if ("string" === t) return "String";
        if (Array.isArray(n)) return "Array";
        if (n instanceof RegExp) return "RegExp";
        var r = n.toString();
        return r.startsWith("async") ? "Async" : "[object Promise]" === r ? "Promise" : r.includes("function") || r.includes("=>") ? "Function" : "Object";
      }
      function h(n, t) {
        if (1 === arguments.length) return function (t) {
          return h(n, t);
        };
        if (n === t) return !0;
        var r = v(n);
        if (r !== v(t)) return !1;
        if ("Array" === r) {
          var e = Array.from(n),
            o = Array.from(t);
          return e.sort().toString() === o.sort().toString();
        }
        if ("Object" === r) {
          var u = Object.keys(n);
          if (u.length === Object.keys(t).length) {
            if (0 === u.length) return !0;
            var i = !0;
            return u.map(function (r) {
              if (i) {
                var e = v(n[r]),
                  o = v(t[r]);
                e === o ? "Object" === e ? Object.keys(n[r]).length === Object.keys(t[r]).length ? 0 !== Object.keys(n[r]).length && (h(n[r], t[r]) || (i = !1)) : i = !1 : h(n[r], t[r]) || (i = !1) : i = !1;
              }
            }), i;
          }
        }
        return !1;
      }
      var b = r(function (n, t) {
        for (var r = -1, e = !1; ++r < t.length && !e;) h(t[r], n) && (e = !0);
        return e;
      });
      function m(n) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
        return function () {
          for (var r = arguments.length, e = Array(r), o = 0; o < r; o++) e[o] = arguments[o];
          return (u = [].concat(d(t), e)).length >= n.length ? n.apply(void 0, d(u)) : m(n, u);
          var u;
        };
      }
      function g(n, t) {
        return 1 === arguments.length ? function (t) {
          return g(n, t);
        } : null == t || !0 === Number.isNaN(t) ? n : t;
      }
      var O = r(function (n, t) {
          return t.slice(n);
        }),
        j = r(function (n, t) {
          return t.slice(0, -n);
        }),
        w = r(function (n, t) {
          return function (r) {
            return n(r) || t(r);
          };
        }),
        x = r(function (n, t) {
          return t.find(n);
        }),
        S = r(function (n, t) {
          for (var r = t.length, e = -1; ++e < r;) if (n(t[e])) return e;
          return -1;
        }),
        P = r(function (n, t) {
          return n(t), t;
        }),
        A = r(function (n, t) {
          if (void 0 === t.length) return function (n, t) {
            var r = {};
            for (var e in t) r[e] = n(t[e]);
            return r;
          }(n, t);
          for (var r = -1, e = t.length, o = Array(e); ++r < e;) o[r] = n(t[r]);
          return o;
        }),
        _ = r(function (n, t) {
          return A(P(n), t);
        }),
        k = r(function (n, t) {
          return void 0 !== t[n];
        }),
        C = e(function (n, t, r) {
          return function (e) {
            return !0 === n(e) ? t(e) : r(e);
          };
        }),
        E = r(function (n, t) {
          for (var r = -1, e = t.length; ++r < e;) if (t[r] === n) return r;
          return -1;
        });
      function T(n, t, r) {
        var e = -1,
          o = n.length;
        (r = r > o ? o : r) < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
        for (var u = Array(o); ++e < o;) u[e] = n[e + t];
        return u;
      }
      var q = r(function (n, t) {
          var r = t.match(n);
          return null === r ? [] : r;
        }),
        R = r(function (n, t) {
          return Object.assign({}, n, t);
        });
      function I(n, t) {
        if (1 === arguments.length) return function (t) {
          return I(n, t);
        };
        if (null != t) {
          var r = t,
            e = 0;
          for ("string" == typeof n && (n = n.split(".")); e < n.length;) {
            if (null == r) return;
            r = r[n[e]], e++;
          }
          return r;
        }
      }
      var W = m(function (n, t, r) {
          return g(n, I(t, r));
        }),
        M = r(function (n, t) {
          var r = [];
          return A(function (t) {
            void 0 !== t[n] && r.push(t[n]);
          }, t), r;
        }),
        N = r(function (n, t) {
          if ("string" == typeof t) return "" + n + t;
          var r = t.concat();
          return r.unshift(n), r;
        }),
        U = r(function (n, t) {
          return t[n];
        }),
        L = e(function (n, t, r) {
          return r[n] === t;
        });
      function B(n, t) {
        for (var r = [], e = n; e < t; e++) r.push(e);
        return r;
      }
      var D = e(function (n, t, r) {
          return r.reduce(n, t);
        }),
        V = r(function (n, t) {
          return Array(t).fill(n);
        }),
        F = e(function (n, t, r) {
          return r.replace(n, t);
        }),
        H = r(function (n, t) {
          return t.concat().sort(n);
        }),
        Y = r(function (n, t) {
          return t.concat().sort(function (t, r) {
            var e = n(t),
              o = n(r);
            return e < o ? -1 : e > o ? 1 : 0;
          });
        }),
        z = r(function (n, t) {
          return t.split(n);
        }),
        G = r(function (n, t) {
          n = n > 1 ? n : 1;
          for (var r = [], e = 0; e < t.length;) r.push(t.slice(e, e += n));
          return r;
        }),
        J = r(function (n, t) {
          return "string" == typeof t ? t.slice(0, n) : T(t, 0, n);
        }),
        K = r(function (n, t) {
          var r = t.length;
          return n = n > r ? r : n, "string" == typeof t ? t.slice(r - n) : T(t, n = r - n, r);
        }),
        Q = r(function (n, t) {
          return -1 !== t.search(n);
        }),
        X = r(function (n, t) {
          return A(n, B(0, t));
        });
      function Z(n, t) {
        return 1 === arguments.length ? function (t) {
          return Z(n, t);
        } : v(t) !== v(n) ? n : t;
      }
      var $ = m(function (n, t, r) {
          return Z(n, I(t, r));
        }),
        nn = e(function (n, t, r) {
          return r.concat().fill(t, n, n + 1);
        }),
        tn = o("+"),
        rn = function n(t, r, e) {
          return void 0 === r ? function (r, e) {
            return n(t, r, e);
          } : void 0 === e ? function (e) {
            return n(t, r, e);
          } : void 0 !== r[t] ? r[t](e) : void 0;
        }("concat"),
        en = o("/"),
        on = t("endsWith"),
        un = t("includes"),
        cn = t("join"),
        fn = t("lastIndexOf"),
        an = function n(t, r) {
          return void 0 === r ? function (r) {
            return n(t, r);
          } : r[t];
        }("length"),
        ln = o("%"),
        sn = o("*"),
        pn = t("padEnd"),
        yn = t("padStart"),
        dn = u("reverse"),
        vn = t("startsWith"),
        hn = o("-"),
        bn = u("toLowerCase"),
        mn = u("toString"),
        gn = u("toUpperCase"),
        On = u("trim");
      n.add = tn, n.always = function (n) {
        return function () {
          return n;
        };
      }, n.complement = function (n) {
        return function (t) {
          return !n(t);
        };
      }, n.concat = rn, n.divide = en, n.endsWith = on, n.F = function () {
        return !1;
      }, n.identity = function (n) {
        return n;
      }, n.includes = un, n.join = cn, n.lastIndexOf = fn, n.length = an, n.modulo = ln, n.multiply = sn, n.not = function (n) {
        return !n;
      }, n.padEnd = pn, n.padStart = yn, n.reverse = dn, n.startsWith = vn, n.subtract = hn, n.T = function () {
        return !0;
      }, n.toLower = bn, n.toString = mn, n.toUpper = gn, n.trim = On, n.addIndex = function (n) {
        return function (t) {
          for (var r = 0, e = arguments.length, o = Array(e > 1 ? e - 1 : 0), u = 1; u < e; u++) o[u - 1] = arguments[u];
          return n.apply(null, [function () {
            for (var n = arguments.length, e = Array(n), o = 0; o < n; o++) e[o] = arguments[o];
            return t.apply(null, [].concat(e, [r++]));
          }].concat(o));
        };
      }, n.adjust = i, n.all = f, n.allPass = function n(t, r) {
        return 1 === arguments.length ? function (r) {
          return n(t, r);
        } : !a(function (n) {
          return !n(r);
        }, t);
      }, n.anyPass = function n(t, r) {
        return 1 === arguments.length ? function (r) {
          return n(t, r);
        } : a(function (n) {
          return n(r);
        })(t);
      }, n.any = a, n.append = l, n.both = s, n.compose = p, n.contains = b, n.curry = m, n.dec = function (n) {
        return n - 1;
      }, n.defaultTo = g, n.drop = O, n.dropLast = j, n.either = w, n.inc = function (n) {
        return n + 1;
      }, n.equals = h, n.filter = c, n.find = x, n.findIndex = S, n.flatten = function n(t, r) {
        r = void 0 === r ? [] : r;
        for (var e = 0; e < t.length; e++) Array.isArray(t[e]) ? n(t[e], r) : r.push(t[e]);
        return r;
      }, n.flip = function (n) {
        return function (n) {
          return function () {
            for (var t = arguments.length, r = Array(t), e = 0; e < t; e++) r[e] = arguments[e];
            return 1 === r.length ? function (t) {
              return n(t, r[0]);
            } : 2 === r.length ? n(r[1], r[0]) : void 0;
          };
        }(n);
      }, n.forEach = _, n.has = k, n.head = function (n) {
        return "string" == typeof n ? n[0] || "" : n[0];
      }, n.ifElse = C, n.isNil = function (n) {
        return null == n;
      }, n.indexOf = E, n.init = function (n) {
        return "string" == typeof n ? n.slice(0, -1) : n.length ? T(n, 0, -1) : [];
      }, n.last = function (n) {
        return "string" == typeof n ? n[n.length - 1] || "" : n[n.length - 1];
      }, n.map = A, n.match = q, n.merge = R, n.omit = function n(t, r) {
        if (1 === arguments.length) return function (r) {
          return n(t, r);
        };
        if (null != r) {
          "string" == typeof t && (t = t.split(",").map(function (n) {
            return n.trim();
          }));
          var e = {};
          for (var o in r) t.includes(o) || (e[o] = r[o]);
          return e;
        }
      }, n.partialCurry = function (n) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return function (r) {
          return "Async" === v(n) || "Promise" === v(n) ? new Promise(function (e, o) {
            n(R(r, t)).then(e).catch(o);
          }) : n(R(r, t));
        };
      }, n.path = I, n.pathOr = W, n.pick = function n(t, r) {
        if (1 === arguments.length) return function (r) {
          return n(t, r);
        };
        if ("Object" === v(r)) {
          "String" === v(t) && (t = t.split(",").map(function (n) {
            return n.trim();
          }));
          for (var e = {}, o = 0; o < t.length;) t[o] in r && (e[t[o]] = r[t[o]]), o++;
          return e;
        }
      }, n.pipe = function () {
        for (var n = arguments.length, t = Array(n), r = 0; r < n; r++) t[r] = arguments[r];
        return p.apply(void 0, d(t.reverse()));
      }, n.pluck = M, n.prepend = N, n.prop = U, n.propEq = L, n.range = B, n.reduce = D, n.repeat = V, n.replace = F, n.sort = H, n.sortBy = Y, n.split = z, n.splitEvery = G, n.tap = P, n.tail = function (n) {
        return O(1, n);
      }, n.take = J, n.takeLast = K, n.test = Q, n.times = X, n.type = v, n.typedPathOr = $, n.typedDefaultTo = Z, n.uniq = function (n) {
        for (var t = -1, r = []; ++t < n.length;) {
          var e = n[t];
          b(e, r) || r.push(e);
        }
        return r;
      }, n.update = nn, n.values = function (n) {
        var t = [];
        for (var r in n) t.push(n[r]);
        return t;
      }, Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }(t);
  }, function (t, r) {
    t.exports = n;
  }, function (n, r) {
    n.exports = t;
  }, function (n, t, r) {
    n.exports = r(7)();
  }, function (n, t, r) {
    var e = r(5),
      o = r(6);
    n.exports = function (n, t, r) {
      var u = t && r || 0;
      "string" == typeof n && (t = "binary" === n ? new Array(16) : null, n = null);
      var i = (n = n || {}).random || (n.rng || e)();
      if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, t) for (var c = 0; c < 16; ++c) t[u + c] = i[c];
      return t || o(i);
    };
  }, function (n, t) {
    var r = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
    if (r) {
      var e = new Uint8Array(16);
      n.exports = function () {
        return r(e), e;
      };
    } else {
      var o = new Array(16);
      n.exports = function () {
        for (var n, t = 0; t < 16; t++) 0 == (3 & t) && (n = 4294967296 * Math.random()), o[t] = n >>> ((3 & t) << 3) & 255;
        return o;
      };
    }
  }, function (n, t) {
    for (var r = [], e = 0; e < 256; ++e) r[e] = (e + 256).toString(16).substr(1);
    n.exports = function (n, t) {
      var e = t || 0,
        o = r;
      return [o[n[e++]], o[n[e++]], o[n[e++]], o[n[e++]], "-", o[n[e++]], o[n[e++]], "-", o[n[e++]], o[n[e++]], "-", o[n[e++]], o[n[e++]], "-", o[n[e++]], o[n[e++]], o[n[e++]], o[n[e++]], o[n[e++]], o[n[e++]]].join("");
    };
  }, function (n, t, r) {
    "use strict";

    var e = r(8);
    function o() {}
    function u() {}
    u.resetWarningCache = o, n.exports = function () {
      function n(n, t, r, o, u, i) {
        if (i !== e) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }
      function t() {
        return n;
      }
      n.isRequired = n;
      var r = {
        array: n,
        bool: n,
        func: n,
        number: n,
        object: n,
        string: n,
        symbol: n,
        any: n,
        arrayOf: t,
        element: n,
        elementType: n,
        instanceOf: t,
        node: n,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: u,
        resetWarningCache: o
      };
      return r.PropTypes = r, r;
    };
  }, function (n, t, r) {
    "use strict";

    n.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (n, t, r) {
    "use strict";

    r.r(t);
    var e = r(4),
      o = r.n(e),
      u = r(2),
      i = r.n(u),
      c = r(1),
      f = r.n(c),
      a = r(3),
      l = r.n(a);
    function s(n) {
      return document.querySelector(n);
    }
    var p = r(0);
    function y(n) {
      return function (n) {
        if (Array.isArray(n)) {
          for (var t = 0, r = new Array(n.length); t < n.length; t++) r[t] = n[t];
          return r;
        }
      }(n) || function (n) {
        if (Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n)) return Array.from(n);
      }(n) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }
    function d(n) {
      return Object(p.reduce)(function (t, r) {
        return t.push(n[r]), t;
      }, [], (t = n, Object.keys(t)));
      var t;
    }
    function v(n, t) {
      var r = s(n);
      if (r) return f.a.render(i.a.createElement("span", null, t), r);
    }
    function h(n, t) {
      return Object(p.compose)((e = [t], (r = v).bind.apply(r, [null].concat(y(e)))), Object(p.reduce)(function (n, t) {
        return n.push(t.element), n;
      }, []), Object(p.filter)(Object(p.propEq)("selector", t)))(d(n));
      var r, e;
    }
    function b(n) {
      return (b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function m(n, t) {
      for (var r = 0; r < t.length; r++) {
        var e = t[r];
        e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(n, e.key, e);
      }
    }
    function g(n, t) {
      return !t || "object" !== b(t) && "function" != typeof t ? function (n) {
        if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return n;
      }(n) : t;
    }
    function O(n) {
      return (O = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function j(n, t) {
      return (j = Object.setPrototypeOf || function (n, t) {
        return n.__proto__ = t, n;
      })(n, t);
    }
    function w(n) {
      var t = function (t) {
        function r() {
          return function (n, t) {
            if (!(n instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), g(this, O(r).apply(this, arguments));
        }
        var e, o, u;
        return function (n, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          n.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: n,
              writable: !0,
              configurable: !0
            }
          }), t && j(n, t);
        }(r, i.a.Component), e = r, (o = [{
          key: "getChildContext",
          value: function value() {
            return n;
          }
        }, {
          key: "render",
          value: function value() {
            return this.props.children;
          }
        }]) && m(e.prototype, o), u && m(e, u), r;
      }();
      return t.propTypes = {
        children: l.a.any.isRequired
      }, t.childContextTypes = {}, Object.keys(n).forEach(function (n) {
        t.childContextTypes[n] = l.a.any.isRequired;
      }), t;
    }
    function x(n) {
      return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function S(n, t) {
      return !t || "object" !== x(t) && "function" != typeof t ? function (n) {
        if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return n;
      }(n) : t;
    }
    function P(n) {
      return (P = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function A(n, t) {
      for (var r = 0; r < t.length; r++) {
        var e = t[r];
        e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(n, e.key, e);
      }
    }
    function _(n, t, r) {
      return t && A(n.prototype, t), r && A(n, r), n;
    }
    function k(n, t) {
      return (k = Object.setPrototypeOf || function (n, t) {
        return n.__proto__ = t, n;
      })(n, t);
    }
    r.d(t, "unMountComponentWillAppendToBody", function () {
      return R;
    }), r.d(t, "componentWillAppendToBody", function () {
      return I;
    });
    var C,
      E,
      T = (C = {
        containerExists: s,
        unMountContainer: function unMountContainer(n) {
          f.a.unmountComponentAtNode(n);
        }
      }, E = function E(n) {
        return Object(p.map)(h.bind(null, n), function (n) {
          return Object(p.compose)(p.uniq, Object(p.map)(Object(p.prop)("selector")))(d(n));
        }(n));
      }, function () {
        var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return {
          updateElement: function updateElement(t, r, e) {
            return n.hasOwnProperty(t) ? n[t].element = r : n[t] = {
              element: r,
              selector: e
            }, E(n);
          },
          deleteElement: function deleteElement(t) {
            if (n.hasOwnProperty(t)) {
              var r = n[t];
              delete n[t];
              var e = C.containerExists(r.selector);
              if (e) return C.unMountContainer(e), E(n);
            }
          }
        };
      }),
      q = T();
    function R() {
      q = T();
    }
    function I(n) {
      return function (t) {
        function r(n, t) {
          var e;
          return function (n, t) {
            if (!(n instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), (e = S(this, P(r).call(this, n))).ContextProvider = w(t), "#subtree-container" === n.subtreeContainer && function () {
            if (!s("#subtree-container")) {
              var n = document.createElement("div");
              n.setAttribute("id", "subtree-container"), n.setAttribute("class", "subtree-container"), document.body.appendChild(n);
            }
          }(), e;
        }
        return function (n, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          n.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: n,
              writable: !0,
              configurable: !0
            }
          }), t && k(n, t);
        }(r, i.a.Component), _(r, null, [{
          key: "defaultProps",
          get: function get() {
            return {
              subtreeContainer: "#subtree-container",
              context: {}
            };
          }
        }, {
          key: "propTypes",
          get: function get() {
            return {
              subtreeContainer: l.a.string,
              className: l.a.string
            };
          }
        }]), _(r, [{
          key: "componentWillMount",
          value: function value() {
            this.uniqueId = o()(), !f.a.createPortal && this.update();
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            !f.a.createPortal && this.update();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            q.deleteElement(this.uniqueId);
          }
        }, {
          key: "getComponent",
          value: function value() {
            var t = this.ContextProvider;
            return i.a.createElement(t, {
              key: this.uniqueId
            }, i.a.createElement(n, this.props));
          }
        }, {
          key: "update",
          value: function value() {
            return q.updateElement(this.uniqueId, this.getComponent(), this.props.subtreeContainer);
          }
        }, {
          key: "render",
          value: function value() {
            return f.a.createPortal ? f.a.createPortal(this.getComponent(), s(this.props.subtreeContainer)) : null;
          }
        }]), r;
      }();
    }
  }]);
});